import { t } from 'i18next'
import { isRussia, isUS } from 'env'

export const getPhonePlaceholder = () => {
  if (isUS) {
    return '+1 (...) ... ....'
  }

  if (isRussia) {
    return '+7 900 000 00 00'
  }
}

export const getPersonalNumberLabel = () => {
  return t('common:inn')
}
